import Api from "@/api/Api";
import errorHandler from "@/utils/plugins/ErrorHandler";

const RESOURCE_TRACKER = "/api/course_requests";

export default {
  async getCourseRequests(params) {
    return await Api()
      .get(RESOURCE_TRACKER, { params: params })
      .catch((err) => errorHandler(err, null));
  },
  async createCourseRequest(params) {
    return Api()
      .post(RESOURCE_TRACKER, params)
      .catch((err) => errorHandler(err, null));
  },
  async updateCourseRequest(id, params) {
    return Api()
      .put(`${RESOURCE_TRACKER}/${id}`, params)
      .catch((err) => errorHandler(err, null));
  },
  async getCourseRequest(id, params) {
    return Api()
      .get(`${RESOURCE_TRACKER}/${id}`, params)
      .catch((err) => errorHandler(err, null));
    },
    async discardCourseRequest(id) {
      return Api()
      .delete(`${RESOURCE_TRACKER}/${id}`)
      .catch((err) => errorHandler(err, null));
    },
    async assignCourseRequest(id, params) {
      return Api()
        .post(RESOURCE_TRACKER+`/${id}/assign`, params)
        .catch((err) => errorHandler(err, null));
    },
};
